import React, { Suspense } from 'react'
import {
    Grid,
    Box,
    InputLabel,
    Select,
    Typography,
    makeStyles,
    useMediaQuery,
    useTheme,
    FormHelperText,
    Tooltip,
    Collapse,
} from '@material-ui/core';

import HelpIcon from '@material-ui/icons/Help';

import { Seperator } from './Seperator';
// import { FamilyTaxBenefits } from './FamilyTaxBenefits';
import { taxData } from '../../../core/calculatorData';
import CheckIcon from '@material-ui/icons/Check';
import { ToggleOptions } from './ToggleOptions';
import { useCalculator, DISPATCH_UPDATE, DISPATCH_UPDATE_SALARY_SACRAFICE, DISPATCH_MAXIMISE_SUPER, DISPATCH_UPDATE_NOVATED_LEASE } from '../../../state/calculatorState';
import { salarySacraficeOptions, novatedLeaseOptions, salaryOptions, FREQUENCY_DESCPIPTION, ANNUALLY } from '../../../core/calculatorConstants';
import { Fallback } from '../../common/LayoutComponents';
import { useLayout } from '../../../state/layoutState';
import {
    StyledTextField,
    StyledSmallSelectControl,
    StyledFormControl,
    CustomSwitch,
    CustomFormControlLabel,
    CustomFormControlNoLabel,
    StyledLink,
    CustomTinyButton,
    CustomCheckbox,
} from '../../common/CustomComponents';
import { PercentFormat, IntegerFormat, PriceIntegerFormat, PriceFormat } from '../../common/customFormatters'
import { getTaxYearIndex } from '../../../core/calculatorUtils';
import { parseInputValue, formatMoney } from '../../../utils/utils'
import {
    ALLOWANCE_TYPES_LINK,
    CARRY_FORWARD_INFO,
    SPOUSE_SUPER_INFO,
    MEDICARE_LEVY_EXPEMTION_INFO,
    MEDICARE_LEVY_DEPENDANTS_INFO,
    MEDICARE_LEVY_VARIATION_INFO,
    STUDENT_LOAN_EXPEMTION_INFO,
    SAPTO_INFO,
    REBATE_INCOME_INFO,
    NOTICE_OF_INTENT_TO_CLAIM,
    SUPER_CO_CONTRIBUTION,
    CAPTIAL_GAINS,
    OTHER_INCOME,
    SMALL_BUSINESS_TAX_OFFSET,
    WORKING_HOLIDAY_MAKERS_TAX,
    NON_RESIDENT_TAX,
    BUSINESS_INCOME_LOSS,
    TAX_OFFSETS_INFO,
    FRANKING_CREDITS_INFO,
    ELIGIBLE_DEDUCTIONS,
    SALARY_SACRIFICE,
    REPORTABLE_SUPER,
} from '../../../constants';

const FamilyTaxBenefits = React.lazy(() => import('./FamilyTaxBenefits'));

const useStyles = makeStyles(theme => {
    return {
        root: {
            '& > *': {
                margin: theme.spacing(1),
            },
            paddingRight: 0,
        },

        active: {
        },
        inactive: {
            '& .MuiFilledInput-root': {
                backgroundColor: 'rgba(0,0,0,0)'
            },
            '& .MuiInput-underline:before, .MuiFilledInput-underline:before': {
                borderColor: theme.palette.secondary.main,
                opacity: 0.2
            },
        },

        helperText: {
            fontStyle: 'italic',
            opacity: 0.5,
            paddingBottom: 4,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.15px",
            lineHeight: "1.25",
        },
        infoText: {
            fontStyle: 'italic',
            opacity: 0.8,
            paddingBottom: 0,
            fontWeight: "bold",
            letterSpacing: "-0.15px",
            color: theme.palette.primary.main,
        },

        alertText: {
            fontStyle: 'italic',
            opacity: 0.8,
            paddingBottom: 0,
            fontWeight: "bold",
            letterSpacing: "-0.15px",
            color: theme.palette.secondary.main,
        },
        switchHelperText: {
            fontStyle: 'italic',
            opacity: 0.5,
            marginTop: -15,
            paddingLeft: 0,
            marginLeft: 45,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.15px",
            lineHeight: "1.0",
        },

        checkboxHelperText: {
            fontStyle: 'italic',
            opacity: 0.5,
            marginTop: -15,
            paddingLeft: 0,
            marginLeft: 30,
            color: theme.palette.primary.contrastText,
            letterSpacing: "-0.15px",
            lineHeight: "1.0",
        },
        inlineHelperText: {
            fontStyle: 'italic',
            opacity: 0.5,
            paddingLeft: 45,
            color: theme.palette.primary.main,
            letterSpacing: "-0.15px",
            lineHeight: "1.25",
        },

        insetInput: {
            paddingTop: 0,
            paddingLeft: 45,
        },

        paddingInput: {
            paddingTop: 10,
        },

        seperator: {
            height: 1,
            backgroundColor: theme.palette.primary.main,
            opacity: 0.5,
            margin: '8px 0 6px 0px',
        },

        footerMargin: {
            paddingBottom: 20,
        }


    }
});


const taxInfo = (tax, theme) => {
    return (
        <Typography display="inline" style={{ fontSize: '1.0em', color: theme.palette.secondary.main, opacity: 1, lineHeight: 1.0, whiteSpace: 'nowrap' }}>
            {`$${formatMoney(parseInputValue(tax), 0)} income tax ${tax >= 0 ? 'saving' : 'liability'}`}
        </Typography>
    )
}

const taxNetInfo = (tax, theme) => {
    return (
        <Typography display="inline" style={{ fontSize: '1.0em', color: theme.palette.secondary.main, opacity: 1, lineHeight: 1.0, whiteSpace: 'nowrap' }}>
            {tax === 0 ?
                (
                    ''
                ) : (
                    `$${formatMoney(parseInputValue(tax), 0)} net tax ${tax >= 0 ? 'saving' : 'liability'}`
                )
            }

        </Typography>
    )
}

const benefitInfo = (tax, theme) => {
    return (
        <Typography display="inline" style={{ fontSize: '1.0em', color: theme.palette.secondary.main, opacity: 1, lineHeight: 1.0, whiteSpace: 'nowrap' }}>
            {tax > 0 ? `$${formatMoney(parseInputValue(tax), 2)} benefit` : `No benefit`}
        </Typography>
    )
}


export const AdvancedOptions = () => {
    const theme = useTheme();
    const classes = useStyles();
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const ToolTipDelay = 200;

    const [{
        currentTaxData,
        year,
        HELP,
        adjustSuperannuation,
        adjustedAnnualTaxableIncome,
        superannationConcessionalRemaining,
        adjustSuperannuationCarryForward,
        superannuationCarryForward,
        noSuperannuation,
        adjustSpouseSuper,
        spouseSuperAmount,
        spouseSuperTaxOffset,
        adjustSalaryScaracfice,
        salaryScaracficeAmount,
        salarySacraficeOption,
        salaryScaracficeMaximise,

        salarySacraficeIncomeAmount,
        salarySacraficeIncomeOption,
        salarySacraficeIncomeSavings,

        additionalSuper,
        concessionalAdditionalSuper,
        additionalSuperMaximise,
        // over65,
        //over71,

        //Noavated Lease
        novatedLeaseAmount,
        novatedLeaseOption,
        novatedLeaseSavings,

        fringeBenefits,
        fringeBenefitsFrequency,
        adjustFringeBenefits,
        includeFringeBenefits,
        reportableFringeBenefits,

        nonResident,
        backpacker,
        WHMIncomeOption,
        haveTFN,
        noTaxFree,
        SAPTO,
        sapto,
        spouseSeparated,
        hasPrivateHealthcare,
        medicareSurcharge,
        medicareExemption,

        spouse,
        spouseIncome,
        dependants,
        dependantsCount,
        childSupport,
        medicareExemptionValue,
        medicareFamilyAdjustment,
        applyMedicareAdjustment,

        superannuationCoContribution,
        superannuationCoContributionAvailable,
        superannuationCoContributionApply,
        superannuationCoContributionNonConcessional,
        superannationNonConcessional,
        superannuationExcess,
        adjustSuperannuationRate,
        superannuationRate,
        reportableSuper,
        superannuationGuaranteeCap,
        superannuationSacraficeSavings,
        superannuationSacraficeNetSavings,
        superannuationConcessionalSavings,
        superannuationConcessionalNetSavings,
        division293,

        allowanceIncome,
        adjustAllowanceIncome,
        allowanceIncomeOption,
        allowanceIncomeTaxable,

        taxableDeductionsTax,
        capitalGainsTax,
        otherIncomeTax,

        otherIncome,
        adjustOtherIncome,
        capitalGains,
        adjustDeductions,
        taxableDeductions,

        businessIncome,
        businessIncomeLoss,
        includeGST,
        businessIncomeTax,
        businessIncomeLossTax,
        includeSMTO,

        taxCredits,
        frankingCredits,

        ftb,

        warnings,

    }, dispatch] = useCalculator();


    const [{
        expandInput_Superannuation,
        expandInput_NovatedLease,
        expandInput_FringeBenefits,
        expandInput_TaxCategory,
        expandInput_MedicareOffsets,
        expandInput_FamilyBenefits,
        expandInput_Deductions,
    },] = useLayout();


    const handleUpdate = (data) => {
        dispatch({
            type: DISPATCH_UPDATE,
            ...data
        })
    }


    const handleMaximise = (data) => {
        dispatch({
            type: DISPATCH_MAXIMISE_SUPER,
            ...data
        })
    }


    const handleUpdateSalarySacrafice = (data) => {
        dispatch({
            type: DISPATCH_UPDATE_SALARY_SACRAFICE,
            ...data
        })
    }

    const handleUpdateNovatedLease = (data) => {
        dispatch({
            type: DISPATCH_UPDATE_NOVATED_LEASE,
            ...data
        })
    }




    const handleUpdateWHMIncome = (data) => {
        dispatch({
            type: DISPATCH_UPDATE,
            ...data
        })
    }


    // Tax Data for current tax year
    const data = currentTaxData ? currentTaxData : taxData[getTaxYearIndex(year)];


    let WHMIncomeRangeOptions = [];

    if (data.taxBackpacker && data.taxBackpacker.brackets !== undefined) {
        // "brackets": [
        //     { "from": 0, "to": 45000, "type": "percent", "nearest": 1, "value": 15 },
        //     { "from": 45000, "to": 120000, "type": "percent", "nearest": 1, "value": 32.5 },
        //     { "from": 120000, "to": 180000, "type": "percent", "nearest": 1, "value": 37 },
        //     { "from": 180000, "to": 0, "type": "percent", "nearest": 1, "value": 45 }],

        WHMIncomeRangeOptions = data.taxBackpacker.brackets.map(item => {
            let from = item.from
            let to = item.to
            let label = from === 0 ? `less than $${formatMoney(item.to, 0)}` : to === 0 ? `$${formatMoney(item.from + 1, 0)} and over` : `$${formatMoney(item.from + 1, 0)} - $${formatMoney(item.to, 0)}`
            return label;
        })
    }


    // let nonConcesssionalCap = 0;
    // // let concessionalCap = 0;

    // if (data.superannuation && data.superannuation.nonConcesssionalCap !== undefined) {
    //     nonConcesssionalCap = Number(data.superannuation.nonConcesssionalCap);
    //     // concessionalCap = Number(data.superannuation.concessionalCap);
    // }

    // check if the spouse tax offset is available
    const spouseSuperOffsetAvailable = data.superannuationSpouseTaxOffset !== undefined;
    const spouseSuperCap = spouseSuperOffsetAvailable ? Number(data.superannuationSpouseTaxOffset.spouseIncomeCap) : 0;

    // check if carry forward is available
    const carryForwardSuperAvailable = data.superannuationCarryForward !== undefined;

    let concessionalCap = Number(data.superannuation.concessionalCap);

    if (data.superannuationCarryForward && adjustSuperannuationCarryForward) {
        concessionalCap += Number(superannuationCarryForward);
    }

    const disableSBTO = data.smallBusinessOffset === undefined;


    // option toggles
    let disableTaxFree = false;
    let disableBackpacker = false;
    // let disableSFSS = false;
    let disableMEDICARE = false;

    if (nonResident || backpacker) {
        disableTaxFree = true;
        disableMEDICARE = true;
        // if (backpacker) {
        //     disableSFSS = true;
        // }
    }

    const hideMedicareOptions = disableMEDICARE || (medicareExemption && medicareExemptionValue === 0);
    const maxDate = new Date(`${Number(year)}-07-01`)
    maxDate.setDate(maxDate.getDate() - 1);

    const paddingStyle = { paddingBottom: small ? 0 : 0 };
    const placeholder = 'Input amount';


    // auto toggle the adjustDeductions
    if ((!adjustDeductions && Number(taxableDeductions > 0)) || (adjustDeductions && Number(taxableDeductions === 0))) {
        handleUpdate({ adjustDeductions: !adjustDeductions })
    }

    let superannuationWarning = '';
    let superannuationInfo = '';

    if (superannationConcessionalRemaining >= 0) {
        // superannuationInfo = `$${formatMoney(superannationConcessionalRemaining, 0)} of $${formatMoney(concessionalCap, 0)} concessional remaining.`
        superannuationInfo = `$${formatMoney(superannationConcessionalRemaining, 0)} concessional superannuation remaining.`
        superannuationInfo = `${superannationConcessionalRemaining === 0 ? "No" : "$"}${superannationConcessionalRemaining === 0 ? '' : formatMoney(superannationConcessionalRemaining, 0)} concessional Super remaining ($${formatMoney(concessionalCap, 0)} cap)`
    }


    let overContributions = false;
    let overSacrifice = false;
    if (superannuationExcess > 0) {
        superannuationWarning = `You're paying $${formatMoney(superannuationExcess, 0)} too much Super!`

        // if( adjustSalaryScaracfice && salaryScaracficeAmount > 0 ) overSacrifice = true
        // if (adjustSuperannuation && additionalSuper > 0) overContributions = true

        if (adjustSuperannuation && additionalSuper > 0) {
            overContributions = true
            if (superannuationExcess > additionalSuper) {
                overSacrifice = true
            }

        } else {
            overSacrifice = true
        }

    } else if (superannationNonConcessional > superannuationCoContributionNonConcessional && Number(superannationNonConcessional) >= 1) {
        superannuationWarning = `You're $${formatMoney(superannationNonConcessional, 0)} over the concessional Super cap`
        if (adjustSuperannuation && additionalSuper > 0) {
            overContributions = true
            if (superannationNonConcessional > additionalSuper) {
                overSacrifice = true
            }

        } else {
            overSacrifice = true
        }

    }


    const activeSuperannuation = noSuperannuation || adjustSuperannuationRate || adjustSalaryScaracfice || adjustSuperannuation || adjustSuperannuationCarryForward || adjustSpouseSuper || (!warnings.superannuationCapped && warnings.maximunContributionsCapActive)
    const activeNovatedLease = novatedLeaseAmount > 0;
    const activeFringBenefits = reportableFringeBenefits > 0 || fringeBenefits > 0;
    const activeTaxCategory = nonResident || backpacker || noTaxFree;
    const activeMedicare = (!hasPrivateHealthcare && medicareSurcharge > 0) || medicareExemption || (!hideMedicareOptions && dependants) || (!hideMedicareOptions && spouse) || SAPTO || spouse
    const activeDeductions = adjustDeductions || adjustAllowanceIncome || adjustOtherIncome || salarySacraficeIncomeAmount > 0;
    const activeFamilyBenefits = ftb.a > 0

    const maxContributionsCap = Number(data.superannuation.maximumContributionBaseQuarter) * 4


    return (
        <form noValidate autoComplete="off">
            <Box className={classes.root} >
                <Grid container spacing={(small ? 1 : 10)} style={{ width: '100%' }} display="flex" >
                    <Grid item sm={12} md={6} style={{ paddingLeft: 0, paddingBottom: 0, paddingTop: 0, width: '100%' }} >

                        <Seperator label="Superannuation" id="Superannuation" active={activeSuperannuation} />
                        <Collapse in={expandInput_Superannuation} style={{ paddingLeft: 2 }} >
                            <Box className={classes.paddingInput}>
                                <Typography variant="body2">Superannuation is money set aside by your employers for your retirement. It is also possible to add money into your Super savings and this can change your income tax.</Typography>
                            </Box>

                            <Box display={"flex"} flexDirection="column" justifyContent={"center"} style={{ height: 40 }}>
                                {superannuationWarning !== '' && (
                                    <FormHelperText className={classes.alertText}>{superannuationWarning}</FormHelperText>
                                )}
                                {superannuationInfo !== '' && superannuationWarning === '' && (
                                    <FormHelperText className={classes.infoText}>{superannuationInfo}</FormHelperText>
                                )}
                                {division293 > 0 && (
                                    <Box style={{ display: 'flex' }}>
                                        <FormHelperText className={classes.alertText} style={{ marginTop: -5 }}>{`Division 293 liability of $${formatMoney(division293, 0)}`}

                                        </FormHelperText>
                                        <Box style={{ marginTop: -4, paddingLeft: 5 }}>
                                            <Tooltip
                                                enterDelay={ToolTipDelay}
                                                title="Division 293 tax is an additional tax on super contributions"
                                                placement="top">

                                                < HelpIcon style={{ width: 15, height: 15, color: theme.palette.secondary.main }} />

                                            </Tooltip>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                            <Grid container >
                                <Grid item xs={5}>


                                    <StyledTextField
                                        label="Superannuation Rate"
                                        fullWidth
                                        error={adjustSuperannuationRate}
                                        disabled={noSuperannuation}
                                        value={superannuationRate > 0 ? superannuationRate : ''}
                                        defaultValue={0}
                                        variant="filled"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputMode: 'decimal',
                                            inputComponent: PercentFormat,
                                            inputProps: {
                                                inputMode: "decimal",
                                                pattern: "[0-9].",
                                            }
                                        }}

                                        onChange={(event) => {
                                            let value = event.target.value;
                                            value = isNaN(value) ? 0 : Number(value);
                                            // check that the rounded version of the rate is different to the formatted value in the field
                                            if (Math.round(superannuationRate * 100) / 100 !== value) {
                                                handleUpdate({ superannuationRate: parseInputValue(value), adjustSuperannuationRate: Number(data.superannuation.rate) !== Number(event.target.value) })
                                            }
                                        }
                                        }
                                        id="superannuationRate"
                                    />
                                </Grid>
                                <Grid item xs={7} >
                                    {/* <Box display="flex" alignItems='center' justifyContent="center" flexDirection="row" style={{height:'100%'}}> */}
                                    <Box style={{ paddingLeft: 10 }}>

                                        {!noSuperannuation && adjustSuperannuationRate ? (
                                            <CustomTinyButton
                                                tabIndex="-1"
                                                variant="contained"
                                                style={{ backgroundColor: adjustSuperannuationRate ? theme.palette.secondary.light : theme.palette.background.paper }}
                                                onClick={() => handleUpdate({ adjustSuperannuationRate: false, superannuationRate: data.superannuation.rate })}
                                            >
                                                Reset rate
                                            </CustomTinyButton>
                                        ) : (
                                            <>
                                                {/* this condition is never true ! */}
                                                {(!superannuationGuaranteeCap && warnings.maximunContributionsCapActive) && !noSuperannuation && superannationConcessionalRemaining > 0 ? (
                                                    <CustomTinyButton
                                                        tabIndex="-1"
                                                        variant="contained"
                                                        style={{ backgroundColor: adjustSuperannuationRate ? theme.palette.primary.light : theme.palette.background.paper }}
                                                        onClick={() => handleMaximise()}
                                                    >
                                                        Maximise RATE
                                                    </CustomTinyButton>
                                                ) : (
                                                    <></>
                                                )}
                                            </>

                                        )}
                                    </Box>
                                    {!noSuperannuation && adjustSuperannuationRate && (
                                        <Box style={{ paddingLeft: 10, position: "relative" }}>
                                            <CustomFormControlLabel style={{ textWrap: "nowrap" }} control={
                                                <CustomCheckbox
                                                    id="ReportableContributionsCheckbox"
                                                    style={{ textWrap: "nowrap" }}
                                                    disabled={!adjustSuperannuationRate}
                                                    checked={reportableSuper}
                                                    onChange={(event) => {
                                                        const checked = event.target.checked;
                                                        // set to capped super
                                                        handleUpdate({
                                                            reportableSuper: checked,
                                                        })
                                                    }}
                                                    color="primary"
                                                />
                                            }
                                                label='Reportable contributions'
                                            />
                                            {reportableSuper ?
                                                <FormHelperText className={classes.checkboxHelperText} >
                                                    Extra Super is <StyledLink tabIndex="-1" href={REPORTABLE_SUPER} aria-label="Government co-contribution" rel="noopener noreferrer" target="_blank"> reportable</StyledLink>

                                                </FormHelperText>
                                                :
                                                <FormHelperText className={classes.checkboxHelperText}>Extra Super is <StyledLink tabIndex="-1" href={REPORTABLE_SUPER} aria-label="Government co-contribution" rel="noopener noreferrer" target="_blank">non-reportable</StyledLink></FormHelperText>
                                            }
                                            <Box style={{ position: "absolute", top: 25, right: -5 }}>
                                                <Tooltip
                                                    enterDelay={ToolTipDelay}
                                                    title="If the employee requests the additional superannuation, it's reportable. If part of the employment contract, it's not. This affects your adjusted taxable income, impacting government benefits, tax offsets, and student debt repayments."
                                                    placement="top">

                                                    < HelpIcon style={{ width: 15, height: 15, color: theme.palette.primary.main }} />

                                                </Tooltip>
                                            </Box>

                                        </Box>
                                    )}
                                </Grid>
                            </Grid>




                            <div>

                                <CustomFormControlLabel control={
                                    <CustomSwitch
                                        id="MaxContributionsBase"
                                        disabled={!warnings.maximunContributionsCapActive}
                                        checked={superannuationGuaranteeCap}
                                        onChange={(event) => {
                                            const checked = event.target.checked;
                                            // set to capped super
                                            handleUpdate({
                                                superannuationGuaranteeCap: checked,
                                                //adjustSuperannuationRate: false,
                                                // superannuationRate: data.superannuation.rate
                                            })
                                        }}
                                        color="primary"
                                    />
                                }
                                    label='Max Contributions Base'
                                />
                                {superannuationGuaranteeCap && warnings.maximunContributionsCapActive ?
                                    <FormHelperText className={classes.switchHelperText}>
                                        {`Employer pays Super Guarantee on $${formatMoney(maxContributionsCap, 0)} only`}
                                    </FormHelperText>
                                    :
                                    <FormHelperText className={classes.switchHelperText}>Employer pays Super Guarantee on all your income</FormHelperText>
                                }
                            </div>


                            <div >
                                <CustomFormControlLabel
                                    control={
                                        <CustomSwitch
                                            id="NoSuperannuationGuarantee"
                                            checked={noSuperannuation}
                                            onChange={(event) => {
                                                const checked = event.target.checked;
                                                handleUpdate({

                                                    noSuperannuation: checked,
                                                    // adjustSuperannuationRate: checked? false : adjustSuperannuationRate,
                                                    //adjustSalaryScaracfice: checked ? false : adjustSalaryScaracfice,
                                                    //superannuationGuaranteeCap: checked ? false : superannuationGuaranteeCap,
                                                })
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label="No Superannuation Guarantee"
                                />
                                <FormHelperText className={classes.switchHelperText}>Sole traders aren't obliged to pay Superannuation</FormHelperText>
                            </div>

                            <div style={paddingStyle}>
                                <CustomFormControlLabel
                                    control={
                                        <CustomSwitch
                                            id="SalarySacrificeSuperannuation"
                                            disabled={noSuperannuation}
                                            checked={adjustSalaryScaracfice}
                                            onChange={(event) => handleUpdate({ adjustSalaryScaracfice: (event.target.checked) })}
                                            color="primary"
                                        />
                                    }
                                    label="Salary Sacrifice Superannuation"
                                />
                                <FormHelperText className={classes.switchHelperText}>Reportable Superannuation contributions</FormHelperText>

                            </div>

                            {!noSuperannuation && adjustSalaryScaracfice && (
                                <Box className={classes.insetInput}>
                                    <div style={paddingStyle}>
                                        <Box display="flex" flexDirection="row" >
                                            <Box flex='3' style={{ paddingRight: 10 }}>

                                                <StyledTextField
                                                    label="Amount"
                                                    fullWidth
                                                    disabled={salaryScaracficeMaximise}
                                                    error={overSacrifice}
                                                    value={salaryScaracficeAmount > 0 ? salaryScaracficeAmount : 0}
                                                    defaultValue={0}
                                                    variant="filled"
                                                    type="text"
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        inputMode: 'decimal',
                                                        inputComponent: salarySacraficeOptions[salarySacraficeOption] === "Percent" ? PercentFormat : salarySacraficeOptions[salarySacraficeOption] === ANNUALLY ? PriceIntegerFormat : PriceFormat,
                                                        inputProps: {
                                                            inputMode: "decimal",
                                                            pattern: "[0-9].",
                                                        }
                                                    }}

                                                    onChange={(event) => {
                                                        let value = event.target.value;
                                                        value = isNaN(value) ? 0 : Number(value);
                                                        handleUpdateSalarySacrafice({ salaryScaracficeAmount: parseInputValue(value) })
                                                    }
                                                    }
                                                    id="salarySacrificeSuper"
                                                />

                                            </Box>
                                            <Box flex='4' >
                                                <StyledFormControl variant="filled" fullWidth >
                                                    <InputLabel htmlFor="salarySacrificeFrequency">Frequency</InputLabel>
                                                    <Select
                                                        native
                                                        variant="filled"
                                                        id="salarySacrificeFrequency"
                                                        onChange={(event) => handleUpdateSalarySacrafice({ salarySacraficeOption: (event.target.value) })}
                                                        value={salarySacraficeOption}
                                                    >
                                                        {salarySacraficeOptions.map((option, index) => (
                                                            <option
                                                                key={option}
                                                                value={index}
                                                            >
                                                                {option}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </StyledFormControl>
                                            </Box>
                                        </Box>
                                    </div>

                                    {superannuationSacraficeSavings > 0 && (
                                        <Box display="flex" flexDirection="column" justifyContent="flex-end" alignItems="flex-end" style={{ paddingTop: 5, marginBottom: -28 }}>

                                            {taxInfo(superannuationSacraficeSavings, theme)}
                                            {taxNetInfo(superannuationSacraficeNetSavings, theme)}
                                            <Tooltip
                                                enterDelay={ToolTipDelay}
                                                title="Net tax saving includes the additional 15% Supercontrinutions tax that is paid from your super fund"
                                                placement="top">

                                                < HelpIcon style={{ width: 15, height: 15, color: theme.palette.secondary.main }} />

                                            </Tooltip>
                                        </Box>
                                    )}

                                    <CustomFormControlLabel
                                        control={
                                            <CustomCheckbox
                                                id="MaximiseCOncesionalCheckBox"
                                                checked={salaryScaracficeMaximise}
                                                onChange={(event) => handleUpdate({ salaryScaracficeMaximise: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label={`Maximise`}
                                    />
                                    <FormHelperText className={classes.checkboxHelperText}>{`Limit to any remaining concessional super`}</FormHelperText>





                                </Box>
                            )}

                            <div style={paddingStyle}>
                                <CustomFormControlLabel
                                    control={
                                        <CustomSwitch
                                            id="VoluntarySuperannuation"
                                            checked={adjustSuperannuation}
                                            onChange={(event) => handleUpdate({ adjustSuperannuation: (event.target.checked) })}
                                            color="primary"
                                        />
                                    }
                                    label="Voluntary Superannuation"
                                />

                                {superannuationCoContributionAvailable ? (
                                    <FormHelperText className={classes.switchHelperText} style={{ paddingBottom:5}} >After tax personal contributions. You're eligible for a <StyledLink tabIndex="-1" href={SUPER_CO_CONTRIBUTION} aria-label="Government co-contribution" rel="noopener noreferrer" target="_blank"> Government co-contribution</StyledLink></FormHelperText>
                                ) : (
                                    <FormHelperText className={classes.switchHelperText} style={{ paddingBottom:5}} >After tax personal contributions</FormHelperText>
                                )}
                            </div>

                            {adjustSuperannuation && (
                                <Box className={classes.insetInput} display="flex" flexDirection="column">
                                    <div style={paddingStyle}>
                                        <StyledTextField
                                            label="Annual contributions"
                                            fullWidth
                                            disabled={additionalSuperMaximise}
                                            error={overContributions}

                                            value={additionalSuper > 0 ? additionalSuper : ''}
                                            defaultValue={0}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                    pattern: "[0-9].",
                                                }
                                            }}
                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                handleUpdate({ additionalSuper: parseInputValue(value) })
                                            }
                                            }
                                            id="additionalSuper"
                                        />
                                    </div>

                                    {concessionalAdditionalSuper >= 0 ? (
                                        <Box display="flex" flexDirection="row" alignItems="flex-start" justifyContent="space-between">

                                            <FormHelperText className={classes.helperText} style={{ paddingRight: 10, lineHeight: 1.0 }}>
                                                You need to give <StyledLink tabIndex="-1" href={NOTICE_OF_INTENT_TO_CLAIM} aria-label="Notice of intent to claim" rel="noopener noreferrer" target="_blank" > notice to your fund </StyledLink> to claim a tax deduction
                                            </FormHelperText>
                                            {superannuationConcessionalSavings > 0 && (
                                                <Box display="flex" flexDirection="column" alignItems="flex-end" style={{ paddingTop: 5 }}>
                                                    {taxInfo(superannuationConcessionalSavings, theme)}
                                                    {taxNetInfo(superannuationConcessionalNetSavings, theme)}

                                                    <Tooltip
                                                        enterDelay={ToolTipDelay}
                                                        title="Net tax saving includes the additional 15% Supercontrinutions tax that is paid from your super fund"
                                                        placement="top">

                                                        < HelpIcon style={{ width: 15, height: 15, color: theme.palette.secondary.main }} />

                                                    </Tooltip>
                                                </Box>
                                            )}

                                        </Box>
                                    ) : (
                                        <FormHelperText className={classes.alertText}></FormHelperText>
                                    )
                                    }

                                    <CustomFormControlLabel
                                        style={{ marginTop: -12 }}
                                        control={
                                            <CustomCheckbox
                                            id="MaximiseAdditionalSuperCheckbox"
                                                checked={additionalSuperMaximise}
                                                onChange={(event) => handleUpdate({ additionalSuperMaximise: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label={`Maximise`}
                                    />
                                    <FormHelperText className={classes.checkboxHelperText}>{`Use all remaining concessional Super`}</FormHelperText>




                                    {superannuationCoContributionAvailable && (
                                        <div>
                                            <CustomFormControlLabel
                                                control={
                                                    <CustomCheckbox
                                                        id="MaximiseCoContributionCheckbox"
                                                        checked={superannuationCoContributionApply}
                                                        onChange={(event) => handleUpdate({ superannuationCoContributionApply: (event.target.checked) })}
                                                        color="primary"
                                                    />
                                                }
                                                label={`Maximise Government super co-contribution`}
                                            />
                                            {superannuationCoContributionApply ? (
                                                <FormHelperText className={classes.checkboxHelperText}>{`$${formatMoney(superannuationCoContributionNonConcessional, 0)} non-concessional super gives an extra $${formatMoney(superannuationCoContribution)} super`}</FormHelperText>
                                            ) : (
                                                <FormHelperText className={classes.checkboxHelperText}>{`Eligible on non-concessional contributions`}</FormHelperText>
                                            )}

                                        </div>
                                    )}
                                    {/* <CustomFormControlLabel
                                        control={
                                            <CustomCheckbox
                                                checked={over71}
                                                //onChange={(event) => handleUpdate({ over71: (event.target.checked), over65: (event.target.checked) })}
                                                onChange={(event) => handleUpdate({ over71: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label={`Over 71`}
                                    />
                                    <FormHelperText className={classes.checkboxHelperText}>{`On 30 June ${year}`}</FormHelperText> */}
                                </Box>
                            )}

                            {carryForwardSuperAvailable && (
                                <div style={paddingStyle}>
                                    <CustomFormControlLabel
                                        control={
                                            <CustomSwitch
                                                id="CarryForwardSuperannuation"
                                                checked={adjustSuperannuationCarryForward}
                                                onChange={(event) => handleUpdate({ adjustSuperannuationCarryForward: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label="Carry forward Superannuation"
                                    />
                                    <FormHelperText className={classes.switchHelperText} style={{ paddingBottom:5}} >{`Unused contributions carried forward from previous years will increase your concessional cap.`} <StyledLink tabIndex="-1" href={CARRY_FORWARD_INFO} aria-label="Carry forward" rel="noopener noreferrer" target="_blank">Limits apply</StyledLink></FormHelperText>
                                     </div>
                            )}


                            {adjustSuperannuationCarryForward && carryForwardSuperAvailable && (
                                <Box className={classes.insetInput}>
                                    <div style={paddingStyle}>
                                        <StyledTextField
                                            label="Carry forward amount"
                                            fullWidth
                                            value={superannuationCarryForward > 0 ? superannuationCarryForward : ''}
                                            defaultValue={0}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputMode: "numeric",
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                },
                                            }}

                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                handleUpdate({ superannuationCarryForward: parseInputValue(value) })
                                            }
                                            }
                                            id="superannuationCarryForward"
                                        />
                                    </div>
                                    <FormHelperText className={classes.alertText}>{`Your Concessional cap is $${formatMoney(concessionalCap, 0)}`}</FormHelperText>
                                    <FormHelperText className={classes.helperText}>{`This field increases your Concessional cap only. To account for how this extra super is contributed, enter the details in the relevant fields above.`} </FormHelperText>
                              
                                </Box>
                            )}



                            <div style={paddingStyle}>
                                <CustomFormControlLabel
                                    control={
                                        <CustomSwitch
                                            id="ContributionsToSpouse"
                                            disabled={!spouseSuperOffsetAvailable}
                                            checked={adjustSpouseSuper}
                                            onChange={(event) => handleUpdate({ adjustSpouseSuper: (event.target.checked) })}
                                            color="primary"
                                        />
                                    }
                                    label="Contributions to Spouse's Super"
                                />
                                <FormHelperText className={classes.switchHelperText}><StyledLink tabIndex="-1" href={SPOUSE_SUPER_INFO} aria-label="Carry forward Superannuation information" rel="noopener noreferrer" target="_blank">Check your eligibility for the tax offset</StyledLink></FormHelperText>
                            </div>

                            {adjustSpouseSuper && spouseSuperOffsetAvailable && (
                                <Box className={classes.insetInput}>
                                    <div style={paddingStyle}>
                                        <StyledTextField
                                            label="Spouse's income"
                                            fullWidth
                                            value={spouseIncome > 0 ? spouseIncome : ''}
                                            defaultValue={0}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputMode: "numeric",
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                },
                                            }}

                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                handleUpdate({ spouseIncome: parseInputValue(value) })
                                            }
                                            }
                                            id="superannuationCarryForward"
                                        />
                                    </div>
                                    <FormHelperText className={classes.helperText}>{`Must be less than $${formatMoney(spouseSuperCap, 0)}`}</FormHelperText>

                                    <div style={paddingStyle}>
                                        <StyledTextField
                                            label="Contributions"
                                            fullWidth
                                            value={spouseSuperAmount > 0 ? spouseSuperAmount : ''}
                                            defaultValue={0}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputMode: "numeric",
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                },
                                            }}

                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                handleUpdate({ spouseSuperAmount: parseInputValue(value) })
                                            }
                                            }
                                            id="superannuationSpouseContribution"
                                        />
                                    </div>
                                    <FormHelperText className={classes.helperText}>Contributions made to your spouse's Superannuation</FormHelperText>
                                </Box>
                            )}

                            {spouseSuperTaxOffset > 0 && (
                                <Box className={classes.insetInput} style={{ marginLeft: -30, paddingTop: 5, display: "flex", flex: 1, flexDirection: "row", alignItems: "center" }}>
                                    <CheckIcon style={{ marginRight: 20, fontSize: 12 }} />
                                    <Box flexDirection="column">
                                        <Typography variation="body2" style={{ fontSize: 12 }} >{`You have a Tax offset of $${formatMoney(spouseSuperTaxOffset, 0)}`}</Typography>
                                    </Box>
                                </Box>
                            )}

                            {/* <div style={paddingStyle}>
                                <CustomFormControlLabel
                                    control={
                                        <CustomSwitch
                                            checked={over65}
                                            onChange={(event) => handleUpdate({ over65: event.target.checked, over71: (event.target.checked ? over71 : false) })}
                                            color="primary"
                                        />
                                    }
                                    label="Over 65"
                                />
                                <FormHelperText className={classes.switchHelperText}>{`Your Superannuation fund cap is $${formatMoney(fundContributionCap, 0)}`}</FormHelperText>
                            </div> */}
                            <Box className={classes.footerMargin} />
                        </Collapse>


                        <Seperator label={`Novated Lease`} id="NovatedLease" active={activeNovatedLease} />
                        <Collapse in={expandInput_NovatedLease} style={{ paddingLeft: 2 }}>
                            <Box className={classes.paddingInput}>
                                <Typography variant="body2">A novated lease allows you to lease a car through your employer, reducing your taxable income and potentially saving on taxes.</Typography>
                            </Box>
                            <Box className={classes.paddingInput}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <StyledTextField
                                            label="Lease Payments"
                                            fullWidth
                                            value={novatedLeaseAmount > 0 ? novatedLeaseAmount : ''}
                                            defaultValue={0}
                                            // placeholder={placeholder}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "decimal",
                                                    pattern: "[0-9].",
                                                }
                                            }}
                                            onChange={(event) => handleUpdateNovatedLease({ novatedLeaseAmount: (event.target.value) })}
                                            id={"novatedLeaseAmount"}

                                        />

                                    </Grid>
                                    <Grid item xs={6}>
                                        <StyledFormControl variant="filled" fullWidth >
                                            <InputLabel htmlFor="novatedLeaseOptions">Frequency</InputLabel>
                                            <Select
                                                native
                                                disabled={novatedLeaseAmount === 0}
                                                variant="filled"
                                                id="novatedLeaseOptions"
                                                onChange={(event) => handleUpdateNovatedLease({ novatedLeaseOption: (event.target.value) })}
                                                value={novatedLeaseOption}
                                            >
                                                {novatedLeaseOptions.map((option, index) => (
                                                    <option
                                                        key={option}
                                                        value={index}
                                                    >
                                                        {option}
                                                    </option>
                                                ))}
                                            </Select>
                                        </StyledFormControl>
                                    </Grid>

                                    <Grid item xs={12} style={{ paddingTop: 0, marginTop: -3 }}>
                                        {novatedLeaseSavings > 0 ? (
                                            <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                                <FormHelperText className={classes.helperText}>Pre-tax payments only; exclude any post-tax contributions.</FormHelperText>
                                                {taxInfo(novatedLeaseSavings, theme)}
                                            </Box>
                                        ) : (
                                            <FormHelperText className={classes.helperText}>Before tax payments</FormHelperText>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box className={classes.footerMargin} />
                        </Collapse>





                        <Seperator label={`Fringe Benefits`} id="FringeBenefits" active={activeFringBenefits} />
                        <Collapse in={expandInput_FringeBenefits} style={{ paddingLeft: 2 }}>
                            <Box className={classes.paddingInput}>
                                <Typography variant="body2">Your employer may provide non-cash benefits in addition to your wage. The value of these benefits is not included as taxable income as your employer pays tax on these benefits.</Typography>
                            </Box>
                            <Box className={classes.paddingInput}>
                                <Box display="flex" flexDirection="row" style={{ paddingBottom: 5 }}>
                                    <Box flex='1' style={{ paddingRight: 25 }}>

                                        <StyledTextField
                                            label={`Fringe Benefits`}
                                            fullWidth
                                            value={fringeBenefits > 0 ? fringeBenefits : ''}
                                            defaultValue={0}
                                            // placeholder={placeholder}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                },
                                            }}
                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                handleUpdate({ fringeBenefits: parseInputValue(value), adjustFringeBenefits: true, adjustReportableFringeBenefits: false })
                                            }}
                                            id={"Fringe Benefits"}
                                        />
                                    </Box>
                                    <Box flex='1'>
                                        <StyledFormControl variant="filled" fullWidth >
                                            <InputLabel htmlFor="FringeBenefitsFrequency">Frequency</InputLabel>
                                            <Select
                                                native
                                                disabled={!adjustFringeBenefits}
                                                variant="filled"
                                                id="FringeBenefitsFrequency"
                                                onChange={(event) => handleUpdateSalarySacrafice({ fringeBenefitsFrequency: (event.target.value) })}
                                                value={fringeBenefitsFrequency}
                                            >
                                                {FREQUENCY_DESCPIPTION.map((option, index) => (
                                                    <option
                                                        key={option}
                                                        value={index}
                                                    >
                                                        {option}
                                                    </option>
                                                ))}
                                            </Select>
                                        </StyledFormControl>
                                    </Box>
                                </Box>
                                <Box>
                                <div style={paddingStyle}>

                                    <CustomFormControlLabel
                                        control={
                                            <CustomSwitch
                                                id="IncludeFringeBenefitSalary"
                                                checked={includeFringeBenefits}
                                                onChange={(event) => handleUpdate({ includeFringeBenefits: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label="Include Fringe Benefits in Salary"
                                    />
                                <FormHelperText className={classes.switchHelperText}>{includeFringeBenefits? `Fringe benefits are included in your salary package.` : `Fringe benefits are provided in addition to your salary` }</FormHelperText>
                            </div>
                                </Box>
                            </Box>

                            <Box display="flex" flexDirection="row" style={{ paddingBottom: 5, paddingTop:10 }}>
                                <Box flex='1' style={{ paddingRight: 0 }}>
                                    <Box className={classes.paddingInput} style={{ paddingBottom: 5 }}>
                                        <Typography variant="h3">Reportable Fringe Benefits Amount</Typography>
                                        <Typography variant="body2">This figure is used in the calculation of your Adjusted Taxable Income (ATI) which is used for Government benefits and obligations including Student Loan repayments. This figure will be included on your income statement. </Typography>
                                    </Box>

                                    <StyledTextField
                                        label={`Reportable Amount`}
                                        fullWidth
                                        value={reportableFringeBenefits > 0 ? reportableFringeBenefits : ''}
                                        defaultValue={0}
                                        // placeholder={placeholder}
                                        variant="filled"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: PriceIntegerFormat,
                                            inputProps: {
                                                inputMode: "numeric",
                                            },
                                        }}
                                        onChange={(event) => {
                                            let value = event.target.value;
                                            value = isNaN(value) ? 0 : Number(value);
                                            handleUpdate({ adjustReportableFringeBenefits: true, reportableFringeBenefits: parseInputValue(value) })
                                        }}
                                        id={"Reportable Amount"}
                                    />
                                    <FormHelperText className={classes.helperText} >{`Your Adjusted Taxable Income is $${formatMoney(adjustedAnnualTaxableIncome, 0)}`}</FormHelperText>

                                </Box>
                            </Box>

                            <Box className={classes.footerMargin} />
                        </Collapse>



                        <Seperator label="Tax category" id="TaxCategory" active={activeTaxCategory} />
                        <Collapse in={expandInput_TaxCategory} style={{ paddingLeft: 2 }}>
                            <Box className={classes.paddingInput}>
                                <Typography variant="body2">Non-residents and Working Holiday Makers have different tax rates applied to their wages. In addition, second jobs are tax differently as the tax-free threshold does not apply.</Typography>
                            </Box>
                            <div style={paddingStyle}>
                                <Tooltip
                                    enterDelay={ToolTipDelay}
                                    title="Generally you're a non resident if you are visiting Australia for less than 6 months. However if you have been living in Australia for more than 6 months, have been in the same job and living in the same residence, you are treated as a resident."
                                    placement="top">
                                    <CustomFormControlLabel
                                        control={
                                            <CustomSwitch
                                                id = "NonResident"
                                                checked={nonResident}
                                                onChange={(event) => handleUpdate({ nonResident: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label="Non Resident"
                                    />
                                </Tooltip>
                                <FormHelperText className={classes.switchHelperText}>{`Check if you're a`} <StyledLink tabIndex="-1" href={NON_RESIDENT_TAX} aria-label="Non resident status" rel="noopener noreferrer" target="_blank"> non resident for tax purposes</StyledLink></FormHelperText>
                            </div>
                            <div style={paddingStyle}>
                                <Tooltip
                                    enterDelay={ToolTipDelay}
                                    title="Working holiday makers who are in Australia on a 417 or 462 visa."
                                    placement="top">
                                    <CustomFormControlLabel
                                        control={
                                            <CustomSwitch
                                                id="WHMSwitch"
                                                checked={disableBackpacker ? false : backpacker}
                                                disabled={disableBackpacker}
                                                onChange={disableBackpacker ? null : (event) => handleUpdate({ backpacker: (event.target.checked), nonResident: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label="Working Holiday Maker"
                                    />
                                </Tooltip>
                                <FormHelperText className={classes.switchHelperText}>{`Visa 417, 462 (Backpacker)`} </FormHelperText>
                                {backpacker && (
                                    <Box className={classes.insetInput}>
                                        <CustomFormControlLabel style={{ paddingRight: 10 }}
                                            control={
                                                <CustomSwitch
                                                    id="TFNSwitch"
                                                    checked={haveTFN}
                                                    onChange={(event) => handleUpdate({ haveTFN: (event.target.checked) })}
                                                    color="primary"
                                                />
                                            }
                                            label="Tax File Number"
                                        />
                                    </Box>
                                )}
                                {backpacker && haveTFN && (
                                    <Box className={classes.insetInput}>
                                        <StyledFormControl variant="filled" fullWidth >
                                            <InputLabel htmlFor="WHMIncome">Total payments made</InputLabel>
                                            <Select
                                                native
                                                variant="filled"
                                                id="WHMIncome"
                                                onChange={(event) => handleUpdateWHMIncome({ WHMIncomeOption: (event.target.value) })}
                                                value={WHMIncomeOption}
                                            >
                                                {WHMIncomeRangeOptions.map((option, index) => (
                                                    <option
                                                        key={option}
                                                        value={index}
                                                    >
                                                        {option}
                                                    </option>
                                                ))}

                                            </Select>
                                        </StyledFormControl>
                                        <FormHelperText className={classes.helperText}>
                                            {`Total payments made so far in the current tax year. `}
                                            <StyledLink tabIndex="-1" href={WORKING_HOLIDAY_MAKERS_TAX} aria-label="Find out more" rel="noopener noreferrer" target="_blank">Find out more</StyledLink>

                                        </FormHelperText>
                                    </Box>
                                )}
                            </div>
                            <div style={paddingStyle}>
                                <Tooltip
                                    enterDelay={ToolTipDelay}
                                    title="You only need to check this option if you are calculating a second salary. If you are a non-resident this will be excluded automatically."
                                    placement="top">
                                    <CustomFormControlLabel
                                        control={
                                            <CustomSwitch
                                                id="NoTFNSwitch"
                                                checked={disableTaxFree ? false : noTaxFree}
                                                disabled={disableTaxFree}
                                                onChange={disableTaxFree ? null : (event) => handleUpdate({ noTaxFree: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label="No tax-free Threshold"
                                    />
                                </Tooltip>
                                <FormHelperText className={classes.switchHelperText}>{`Apply for tax on a second job`} </FormHelperText>
                            </div>
                            <Box className={classes.footerMargin} />
                        </Collapse>

                    </Grid>

                    <Grid item sm={12} md={6} style={{ paddingLeft: small ? 0 : 12, paddingBottom: 0, paddingTop: 0 }} >
                        <Box display="flex" flexDirection="column" height="100%">

                            <Seperator label={`Medicare & Senior offset`} id="MedicareOffsets" active={activeMedicare} />
                            <Collapse in={expandInput_MedicareOffsets} style={{ paddingLeft: 2 }} >
                                <Box className={classes.paddingInput}>
                                    <Typography variant="body2">Medicare is a levy on income and funds the public health system. It's set at 2% but some circumstances the amount can vary. Tax offsets are also available for senior Australians.</Typography>
                                </Box>
                                <div style={paddingStyle}>
                                    <Grid container style={{ display: "flex" }}>


                                        <Grid item xs={12}>
                                            <CustomFormControlLabel
                                                control={
                                                    <CustomSwitch
                                                        id="PrivateHealthcareSwitch"
                                                        checked={hasPrivateHealthcare}
                                                        disabled={medicareSurcharge === 0}
                                                        onChange={(event) => handleUpdate({ hasPrivateHealthcare: (event.target.checked) })}
                                                        color="primary"
                                                    />
                                                }
                                                label="Private healthcare"
                                            />
                                            <FormHelperText className={classes.switchHelperText}>
                                                {medicareSurcharge === 0 ? 'You are below the Medicare surcharge threshold' : `You may require private healthcare to avoid a Medicare surcharge of $${formatMoney(medicareSurcharge, 0)}`}

                                            </FormHelperText>
                                        </Grid>


                                        <Grid item >
                                            <Tooltip
                                                enterDelay={ToolTipDelay}
                                                title="If you are not entitled to Medicare, you will not pay the levy."
                                                placement="top">
                                                <CustomFormControlLabel
                                                    control={
                                                        <CustomSwitch
                                                            id="MedicareExemptionSwitch"
                                                            checked={medicareExemption}
                                                            disabled={disableMEDICARE}
                                                            onChange={(event) => handleUpdate({ medicareExemption: (event.target.checked) })}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Medicare Exemption"
                                                />

                                            </Tooltip>
                                            <FormHelperText className={classes.switchHelperText}>
                                                <StyledLink tabIndex="-1" href={MEDICARE_LEVY_EXPEMTION_INFO} aria-label="Check eligibility" rel="noopener noreferrer" target="_blank">Check your eligibility</StyledLink>

                                            </FormHelperText>

                                        </Grid>

                                        {medicareExemption && !disableMEDICARE && (
                                            <Grid item style={{ flex: 1, paddingRight: 20, visibility: medicareExemption && !disableMEDICARE ? "visible" : "hidden" }}>
                                                <StyledSmallSelectControl disabled={!medicareExemption} fullWidth style={{ paddingBottom: 0 }}>
                                                    <Select
                                                        native
                                                        id="exemption"
                                                        // onChange={handleUpdate()}
                                                        onChange={(event) => handleUpdate({ medicareExemptionValue: (event.target.value) })}
                                                        value={medicareExemptionValue}
                                                    >
                                                        <option value={1}>Full</option>
                                                        <option value={0.5}>Half</option>
                                                    </Select>
                                                </StyledSmallSelectControl>
                                            </Grid>
                                        )}


                                    </Grid>
                                    {medicareExemption && HELP && (
                                        <FormHelperText className={classes.inlineHelperText}>
                                            <StyledLink tabIndex="-1" href={STUDENT_LOAN_EXPEMTION_INFO} aria-label="Student Loan exemption" rel="noopener noreferrer" target="_blank">You may be exemptfrom your student loan repayments</StyledLink>
                                        </FormHelperText>
                                    )}
                                </div>

                                <div style={paddingStyle}>
                                    <CustomFormControlLabel
                                        control={
                                            <CustomSwitch
                                                id="DependantChildrenSwitch"
                                                disabled={hideMedicareOptions}
                                                checked={dependants}
                                                onChange={(event) => handleUpdate({ dependants: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label="Dependant Children"
                                    />
                                    <FormHelperText className={classes.switchHelperText}>
                                        <StyledLink tabIndex="-1" href={MEDICARE_LEVY_DEPENDANTS_INFO} aria-label="Check dependant eligibility" rel="noopener noreferrer" target="_blank">Check the eligibility of dependant children</StyledLink>

                                    </FormHelperText>
                                </div>
                                {!hideMedicareOptions && dependants && (
                                    <Box className={classes.insetInput} style={{ paddingTop: 10 }}>
                                        <div style={paddingStyle}>
                                            <StyledTextField
                                                label="Number of dependants"
                                                fullWidth
                                                value={dependantsCount > 0 ? dependantsCount : ''}
                                                defaultValue={0}
                                                variant="filled"
                                                type="text"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputMode: "decimal",
                                                    inputComponent: IntegerFormat,
                                                    inputProps: {
                                                        inputMode: "decimal",
                                                        pattern: "[0-9]",
                                                    }
                                                }}

                                                onChange={(event) => {
                                                    let value = event.target.value;
                                                    value = isNaN(value) ? 0 : Number(value);
                                                    handleUpdate({ dependantsCount: parseInputValue(value) })
                                                }
                                                }
                                                id="dependants"
                                            />
                                        </div>



                                        {medicareFamilyAdjustment && (
                                            <div style={paddingStyle}>
                                                <CustomFormControlLabel
                                                    control={
                                                        <CustomCheckbox
                                                            id="ApplyMedicareAdjustmentCheckbox"
                                                            disabled={!medicareFamilyAdjustment}
                                                            checked={applyMedicareAdjustment}
                                                            onChange={(event) => handleUpdate({ applyMedicareAdjustment: (event.target.checked) })}
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Apply Medicare Adjustment"
                                                />
                                                <FormHelperText className={classes.checkboxHelperText}>
                                                    {applyMedicareAdjustment && (
                                                        <>
                                                            <Typography variation="body2" style={{ fontSize: 12 }} >You must complete the</Typography>
                                                            <StyledLink tabIndex="-1" href={MEDICARE_LEVY_VARIATION_INFO} style={{ color: theme.palette.text.link }} aria-label="Medicare levy variation declaration" rel="noopener noreferrer" target="_blank"> Medicare levy variation declaration</StyledLink>
                                                        </>
                                                    )}
                                                    {!applyMedicareAdjustment && "You're eligible for a medicare adjustment to reduce your tax withholding."}
                                                </FormHelperText>
                                            </div>
                                        )}

                                        <div style={{ paddingTop: 10 }}>
                                            <StyledTextField
                                                label="Child Support payments"
                                                fullWidth
                                                value={childSupport > 0 ? childSupport : ''}
                                                defaultValue={0}
                                                variant="filled"
                                                type="text"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputMode: "numeric",
                                                    inputComponent: PriceIntegerFormat,
                                                    inputProps: {
                                                        inputMode: "numeric",
                                                    },
                                                }}

                                                onChange={(event) => {
                                                    let value = event.target.value;
                                                    value = isNaN(value) ? 0 : Number(value);
                                                    handleUpdate({ childSupport: parseInputValue(value) })
                                                }
                                                }
                                                id="childSupport"
                                            />
                                            <FormHelperText className={classes.helperText}>
                                                {`Total annual benefits you provided to another person other than your partner for the maintenance of your ${dependantsCount === 1 ? 'child' : 'children'}`}
                                            </FormHelperText>
                                        </div>

                                    </Box>
                                )}


                                <div style={paddingStyle}>
                                    <CustomFormControlNoLabel
                                        control={
                                            <CustomSwitch
                                                id="HasSpouseSwitch"
                                                disabled={hideMedicareOptions}
                                                checked={spouse}
                                                onChange={(event) => handleUpdate({ spouse: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label="Spouse (married or de-facto)"
                                    />
                                </div>

                                {!hideMedicareOptions && spouse && (
                                    <Box className={classes.insetInput}>
                                        <div style={paddingStyle}>
                                            <StyledTextField
                                                label="Spouse's Annual Income"
                                                fullWidth
                                                value={spouseIncome !== 0 ? spouseIncome : ''}
                                                placeholder={placeholder}
                                                variant="filled"
                                                type="text"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputMode: "numeric",
                                                    inputComponent: PriceIntegerFormat,
                                                    inputProps: {
                                                        inputMode: "numeric",
                                                    },
                                                }}

                                                onChange={(event) => {
                                                    let value = event.target.value;
                                                    value = isNaN(value) ? 0 : Number(value);
                                                    handleUpdate({ spouseIncome: parseInputValue(value) })
                                                }
                                                }
                                                id="spouseAnnualIncome"
                                            />
                                        </div>
                                        <FormHelperText className={classes.helperText}>
                                            Use their <StyledLink tabIndex="-1" href={REBATE_INCOME_INFO} aria-label="Rebate Income" rel="noopener noreferrer" target="_blank">Rebate Income</StyledLink>
                                        </FormHelperText>
                                    </Box>
                                )}


                                <div style={paddingStyle}>
                                    <CustomFormControlLabel
                                        control={
                                            <CustomSwitch
                                                id="HasSAPTOSwitch"
                                                checked={SAPTO}
                                                onChange={(event) => handleUpdate({ SAPTO: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                        label={`Senior & pensioner offset (SAPTO)`}
                                    />


                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <FormHelperText className={classes.switchHelperText}>
                                            Refer to <StyledLink tabIndex="-1" href={SAPTO_INFO} aria-label="Check eligibility" rel="noopener noreferrer" target="_blank">eligibility criteria</StyledLink>
                                        </FormHelperText>
                                        {SAPTO && (
                                            benefitInfo(sapto, theme)
                                        )}

                                    </Box>
                                </div>

                                {SAPTO && spouse && (
                                    <Box className={classes.insetInput} style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center" }}>
                                        <CustomFormControlLabel
                                            control={
                                                <CustomSwitch
                                                    id="IsSeperatedSwitch"
                                                    checked={spouseSeparated}
                                                    onChange={(event) => handleUpdate({ spouseSeparated: (event.target.checked) })}
                                                    color="primary"
                                                />
                                            }
                                            label="Seperated due to illness"
                                        />
                                    </Box>
                                )}
                                <Box className={classes.footerMargin} />

                            </Collapse>




                            {/* -------------------------------------------------------------------- */}
                            {/* ------------------------ FAMILY TAX BENEFITS ----------------------- */}
                            {/* -------------------------------------------------------------------- */}

                            <Seperator label={`Family Tax Benefit`} id="FamilyBenefits" active={activeFamilyBenefits} />
                            <Collapse in={expandInput_FamilyBenefits} style={{ paddingLeft: 2 }} >
                                <Suspense fallback={<Fallback />}>
                                    <FamilyTaxBenefits />
                                </Suspense>
                                <Box className={classes.footerMargin} />
                            </Collapse>




                            {/* -------------------------------------------------------------------- */}

                            <Seperator label={`Deductions & Other Income`} id="Deductions" active={activeDeductions} />
                            <Collapse in={expandInput_Deductions} style={{ paddingLeft: 2 }} >
                                <Box className={classes.paddingInput}>
                                    <Typography variant="body2">You can claim deductions for some expenses you incur by reducing your taxable income. Other sources of income will increase your tax liabilities.</Typography>
                                </Box>
                                <Box className={classes.paddingInput}>
                                    <Box>
                                        <StyledTextField
                                            label={`Annual tax deductions`}
                                            fullWidth
                                            value={taxableDeductions > 0 ? taxableDeductions : ''}
                                            defaultValue={0}
                                            // placeholder={placeholder}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                },
                                            }}

                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                const adjust = value !== 0;

                                                handleUpdate({ taxableDeductions: parseInputValue(value), adjustDeductions: adjust })
                                            }}
                                            id="taxableDeductions"
                                        />
                                    </Box>

                                </Box>

                                {taxableDeductionsTax > 0 ? (

                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <FormHelperText className={classes.helperText}>Total <StyledLink tabIndex="-1" href={ELIGIBLE_DEDUCTIONS} aria-label="Eligible tax deductions" rel="noopener noreferrer" target="_blank">eligible </StyledLink>tax deductions</FormHelperText>

                                        {taxInfo(taxableDeductionsTax, theme)}
                                    </Box>
                                ) : (
                                    <FormHelperText className={classes.helperText}>Total <StyledLink tabIndex="-1" href={ELIGIBLE_DEDUCTIONS} aria-label="Eligible tax deductions" rel="noopener noreferrer" target="_blank">eligible </StyledLink>tax deductions</FormHelperText>
                                )}

                                <Box className={classes.paddingInput}>
                                    <div style={paddingStyle}>
                                        <Box display="flex" flexDirection="row" >
                                            <Box flex='1' style={{ paddingRight: 10 }}>

                                                <StyledTextField
                                                    label="Salary Sacrifice"
                                                    fullWidth
                                                    value={salarySacraficeIncomeAmount > 0 ? salarySacraficeIncomeAmount : ''}
                                                    defaultValue={0}
                                                    // placeholder={placeholder}
                                                    variant="filled"
                                                    type="text"
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        inputComponent: salarySacraficeOptions[salarySacraficeIncomeOption] === "Percent" ? PercentFormat : PriceIntegerFormat,
                                                        inputProps: {
                                                            inputMode: "decimal",
                                                            pattern: "[0-9].",
                                                        }
                                                    }}

                                                    onChange={(event) => {
                                                        let value = event.target.value;
                                                        value = isNaN(value) ? 0 : Number(value);
                                                        handleUpdateSalarySacrafice({ salarySacraficeIncomeAmount: parseInputValue(value) })
                                                    }
                                                    }
                                                    id="salarySacrificeIncome"
                                                />

                                            </Box>
                                            <Box flex='1' >
                                                <StyledFormControl variant="filled" fullWidth >
                                                    <InputLabel htmlFor="salarySacrificeOptionFrequency">Frequency</InputLabel>
                                                    <Select
                                                        native
                                                        disabled={salarySacraficeIncomeAmount === 0}
                                                        variant="filled"
                                                        id="salarySacrificeOptionFrequency"
                                                        onChange={(event) => handleUpdateSalarySacrafice({ salarySacraficeIncomeOption: (event.target.value) })}
                                                        value={salarySacraficeIncomeOption}
                                                    >
                                                        {salarySacraficeOptions.map((option, index) => (
                                                            <option
                                                                key={option}
                                                                value={index}
                                                            >
                                                                {option}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </StyledFormControl>
                                            </Box>
                                        </Box>
                                    </div>

                                    {taxableDeductionsTax > 0 ? (
                                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                            <FormHelperText className={classes.helperText}><StyledLink tabIndex="-1" href={SALARY_SACRIFICE} aria-label="Salary Sacrifice arrangement" rel="noopener noreferrer" target="_blank">Salary Sacrifice arrangements </StyledLink> other than super</FormHelperText>
                                            {taxInfo(salarySacraficeIncomeSavings, theme)}
                                        </Box>
                                    ) : (
                                        <FormHelperText className={classes.helperText}><StyledLink tabIndex="-1" href={SALARY_SACRIFICE} aria-label="Salary Sacrifice arrangement" rel="noopener noreferrer" target="_blank">Salary Sacrifice arrangements </StyledLink> other than super</FormHelperText>
                                    )}
                                </Box>


                                <Box className={classes.paddingInput}>
                                    <Box>
                                        <StyledTextField
                                            label="Capital gains"
                                            fullWidth
                                            value={capitalGains !== 0 ? capitalGains : ''}
                                            defaultValue={0}
                                            // placeholder={placeholder}
                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                },
                                            }}

                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                value = value < 0 ? 0 : value;
                                                handleUpdate({ capitalGains: value })
                                            }}
                                            id="captialGains"
                                        />
                                    </Box>

                                </Box>

                                {capitalGainsTax !== 0 ? (
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <FormHelperText className={classes.helperText} >Annual reportable <StyledLink tabIndex="-1" href={CAPTIAL_GAINS} aria-label="Captial Gains" rel="noopener noreferrer" target="_blank" >Capital Gains</StyledLink></FormHelperText>
                                        {taxInfo(capitalGainsTax, theme)}
                                    </Box>

                                ) : (
                                    <FormHelperText className={classes.helperText} >Annual reportable <StyledLink tabIndex="-1" href={CAPTIAL_GAINS} aria-label="Captial Gains" rel="noopener noreferrer" target="_blank" >Capital Gains</StyledLink></FormHelperText>
                                )}



                                <Box display="flex" flexDirection="row" className={classes.paddingInput} >
                                    <Box display="flex" flex="1" style={paddingStyle}>
                                        <StyledTextField
                                            label="Allowances"
                                            fullWidth
                                            value={allowanceIncome > 0 ? allowanceIncome : ''}
                                            defaultValue={0}
                                            // placeholder={placeholder}

                                            variant="filled"
                                            type="text"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                                inputComponent: PriceIntegerFormat,
                                                inputProps: {
                                                    inputMode: "numeric",
                                                },
                                            }}
                                            onChange={(event) => {
                                                let value = event.target.value;
                                                value = isNaN(value) ? 0 : Number(value);
                                                const adjust = value !== 0;
                                                handleUpdate({ allowanceIncome: parseInputValue(value), adjustAllowanceIncome: adjust })
                                            }}
                                            id="allowanceIncome"
                                        />
                                    </Box>

                                    <Box display="flex" flex="1" style={{ paddingLeft: 10 }}>
                                        <StyledFormControl variant="filled" fullWidth >
                                            <InputLabel htmlFor="allowanceIncomeOption">Frequency</InputLabel>
                                            <Select
                                                disabled={!adjustAllowanceIncome}
                                                native
                                                variant="filled"
                                                id="allowanceIncomeOption"
                                                onChange={(event) => {
                                                    let value = event.target.value;
                                                    value = isNaN(value) ? 0 : Number(value);
                                                    handleUpdate({ allowanceIncomeOption: value })
                                                }
                                                }
                                                value={allowanceIncomeOption}
                                            >
                                                {salaryOptions.map((option, index) => (
                                                    <option
                                                        key={option}
                                                        value={index}
                                                    >
                                                        {option}
                                                    </option>
                                                ))}
                                            </Select>
                                        </StyledFormControl>
                                    </Box>

                                </Box>
                                <Box display="flex" flexDirection="row" alignItems="center" className={classes.paddingInput} style={{ paddingBottom: 6, paddingTop: 0 }}>
                                    <Box >
                                        <CustomFormControlNoLabel
                                            control={
                                                <CustomCheckbox
                                                    id="OTECheckBox"
                                                    disabled={allowanceIncome === 0}
                                                    checked={allowanceIncomeTaxable}
                                                    onChange={(event) => handleUpdate({ allowanceIncomeTaxable: (event.target.checked) })}
                                                    color="primary"
                                                />
                                            }
                                            label='OTE / Taxable'
                                        />
                                    </Box>

                                    {allowanceIncomeTaxable ? (
                                        <FormHelperText className={classes.helperText} >
                                            Allowance income is part of your Ordinary Taxable Earnings (OTE). Tax witholding and superannuation guarantee apply. Check <StyledLink tabIndex="-1" href={ALLOWANCE_TYPES_LINK} aria-label="Other allowances" rel="noopener noreferrer" target="_blank"> types of allowances</StyledLink>
                                        </FormHelperText>
                                    ) : (
                                        <FormHelperText className={classes.helperText} >
                                            Allowance income is a non taxable fringe benefit on top of your income. Check <StyledLink tabIndex="-1" href={ALLOWANCE_TYPES_LINK} aria-label="Other allowances" rel="noopener noreferrer" target="_blank"> types of allowances</StyledLink>
                                        </FormHelperText>
                                    )}

                                </Box>

                                <Box display="flex" flexDirection="row" className={classes.paddingInput} >
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <StyledTextField
                                                label="Business income"
                                                fullWidth
                                                value={businessIncome !== 0 ? businessIncome : ''}
                                                defaultValue={0}
                                                // placeholder={placeholder}
                                                variant="filled"
                                                type="text"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: PriceIntegerFormat,
                                                    inputProps: {
                                                        inputMode: "numeric",
                                                    },
                                                }}
                                                onChange={(event) => {
                                                    let value = event.target.value;
                                                    value = isNaN(value) ? 0 : Number(value);
                                                    handleUpdate({ businessIncome: value })
                                                }}
                                                id="businessIncome"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Box style={{ paddingLeft: 20, paddingTop: 8 }} >
                                                <CustomFormControlNoLabel control={

                                                    <CustomCheckbox
                                                        id="IncludesGSTCheckBox"
                                                        disabled={businessIncome === 0}
                                                        checked={includeGST}
                                                        onChange={(event) => handleUpdate({ includeGST: (event.target.checked) })}
                                                        color="primary"
                                                    />
                                                }
                                                    label='Includes GST'
                                                />

                                            </Box>
                                        </Grid>
                                    </Grid>



                                </Box>
                                {businessIncomeTax !== 0 ? (
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <FormHelperText className={classes.helperText} >Small business or sole-trader income</FormHelperText>
                                        {taxInfo(businessIncomeTax, theme)}
                                    </Box>
                                ) : (
                                    <FormHelperText className={classes.helperText} >Small business or sole-trader income</FormHelperText>
                                )}

                                {!disableSBTO && (
                                    <Box display="flex" flexDirection="column"  >
                                        <CustomFormControlLabel control={

                                            <CustomSwitch
                                                id="ClaimSmallBusinessSwitch"
                                                disabled={businessIncome === 0}
                                                checked={includeSMTO}
                                                onChange={(event) => handleUpdate({ includeSMTO: (event.target.checked) })}
                                                color="primary"
                                            />
                                        }
                                            label='Claim Small Business Offset'
                                        />
                                        <FormHelperText className={classes.switchHelperText}>
                                            Check the <StyledLink tabIndex="-1" href={SMALL_BUSINESS_TAX_OFFSET} aria-label="Small business tax offset" rel="noopener noreferrer" target="_blank"> eligibility criteria</StyledLink>.
                                        </FormHelperText>
                                    </Box>

                                )}

                                <Box display="flex" flexDirection="row" className={classes.paddingInput} >
                                    <StyledTextField
                                        label="Business loss"
                                        fullWidth
                                        value={businessIncomeLoss !== 0 ? businessIncomeLoss : ''}
                                        defaultValue={0}
                                        // placeholder={placeholder}
                                        variant="filled"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: PriceIntegerFormat,
                                            inputProps: {
                                                inputMode: "numeric",
                                            },
                                        }}
                                        onChange={(event) => {
                                            let value = event.target.value;
                                            value = isNaN(value) ? 0 : Number(value);
                                            handleUpdate({ businessIncomeLoss: value })
                                        }}
                                        id="businessLoss"
                                    />
                                </Box>

                                {businessIncomeLossTax !== 0 ? (
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <FormHelperText className={classes.helperText} > <StyledLink tabIndex="-1" href={BUSINESS_INCOME_LOSS} aria-label="Other Income" rel="noopener noreferrer" target="_blank"> Business income loss</StyledLink> from this year or carried over</FormHelperText>
                                        {taxInfo(businessIncomeLossTax, theme)}
                                    </Box>
                                ) : (
                                    <FormHelperText className={classes.helperText} > <StyledLink tabIndex="-1" href={BUSINESS_INCOME_LOSS} aria-label="Other Income" rel="noopener noreferrer" target="_blank"> Business income loss</StyledLink> from this year or carried over</FormHelperText>
                                )}

                                <Box display="flex" flexDirection="row" className={classes.paddingInput} >
                                    <StyledTextField
                                        label="Dividends & Other income"
                                        fullWidth
                                        value={otherIncome !== 0 ? otherIncome : ''}
                                        defaultValue={0}
                                        // placeholder={placeholder}
                                        variant="filled"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: PriceIntegerFormat,
                                            inputProps: {
                                                inputMode: "numeric",
                                            },
                                        }}
                                        onChange={(event) => {
                                            let value = event.target.value;
                                            value = isNaN(value) ? 0 : Number(value);
                                            const adjust = value !== 0;
                                            handleUpdate({ otherIncome: value, adjustOtherIncome: adjust })
                                        }}
                                        id="otherIncome"
                                    />
                                </Box>


                                {otherIncomeTax !== 0 ? (
                                    <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                                        <FormHelperText className={classes.helperText} >Check types of <StyledLink tabIndex="-1" href={OTHER_INCOME} aria-label="Other Income" rel="noopener noreferrer" target="_blank"> other income</StyledLink></FormHelperText>

                                        {taxInfo(otherIncomeTax, theme)}
                                    </Box>
                                ) : (
                                    <FormHelperText className={classes.helperText} >Check types of <StyledLink tabIndex="-1" href={OTHER_INCOME} aria-label="Other Income" rel="noopener noreferrer" target="_blank"> other income</StyledLink></FormHelperText>
                                )}

                                <Box display="flex" flexDirection="row" className={classes.paddingInput} >
                                    <StyledTextField
                                        label="Franking credits"
                                        fullWidth
                                        value={frankingCredits !== 0 ? frankingCredits : ''}
                                        defaultValue={0}
                                        // placeholder={placeholder}
                                        variant="filled"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: PriceIntegerFormat,
                                            inputProps: {
                                                inputMode: "numeric",
                                            },
                                        }}
                                        onChange={(event) => {
                                            let value = event.target.value;
                                            value = isNaN(value) ? 0 : Number(value);
                                            handleUpdate({ frankingCredits: value })
                                        }}
                                        id="taxcredits"
                                    />
                                </Box>
                                <FormHelperText className={classes.helperText} ><StyledLink tabIndex="-1" href={FRANKING_CREDITS_INFO} aria-label="Other Income" rel="noopener noreferrer" target="_blank">Franking tax offsets</StyledLink> from dividends</FormHelperText>


                                <Box display="flex" flexDirection="row" className={classes.paddingInput} >
                                    <StyledTextField
                                        label="Other Tax offsets/credits"
                                        fullWidth
                                        value={taxCredits !== 0 ? taxCredits : ''}
                                        defaultValue={0}
                                        // placeholder={placeholder}
                                        variant="filled"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            inputComponent: PriceIntegerFormat,
                                            inputProps: {
                                                inputMode: "numeric",
                                            },
                                        }}
                                        onChange={(event) => {
                                            let value = event.target.value;
                                            value = isNaN(value) ? 0 : Number(value);
                                            handleUpdate({ taxCredits: value })
                                        }}
                                        id="taxoffsets"
                                    />
                                </Box>
                                <FormHelperText className={classes.helperText} >Other <StyledLink tabIndex="-1" href={TAX_OFFSETS_INFO} aria-label="Other Income" rel="noopener noreferrer" target="_blank"> tax offsets or credits</StyledLink></FormHelperText>

                                <Box className={classes.footerMargin} />
                            </Collapse>

                        </Box>
                    </Grid>

                </Grid>
                <ToggleOptions />
            </Box >
        </form>
    );

}
